<template>
  <el-container class="f-h" ref="scrollDiv">
    <el-header class="sub-header" style="height: 50px">
      <el-row type="flex" justify="space-between">
        <el-row type="flex" align="middle">
          <span v-if="!isEmbed" class="sub-title">医嘱：</span>
          <el-radio-group v-if="setting.isSimple" v-model="condition.term" class="right-pad" @change="page" size="small" fill="#909399">
            <el-radio-button label="长期">长期</el-radio-button>
            <el-radio-button label="临时">临时</el-radio-button>
          </el-radio-group>

          <template v-if="!readonly">
            <el-dropdown @command="stateChange" class="right-pad">
              <el-tag class="primary pointer" type="primary" hit> {{ action }} <i class="el-icon-arrow-down el-icon--right"></i> </el-tag>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="全 部">全 部</el-dropdown-item>
                <el-dropdown-item command="校对"><i class="el-icon-thumb" /> 待校对</el-dropdown-item>
                <el-dropdown-item command="执行"><i class="el-icon-position" /> 待执行</el-dropdown-item>
                <el-dropdown-item command="确认停止"><i class="el-icon-switch-button" /> 待停止</el-dropdown-item>
                <!-- <el-dropdown-item v-for="state in stateOptions" :command="state.key" :key="state.key"><i :class="state.icon" /> {{ state.name }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>

            <el-button v-if="action == '校对'" type="warning" size="small" icon="el-icon-thumb" @click="confirm">执行校对</el-button>
            <el-button v-if="action == '确认停止'" type="danger" size="small" icon="el-icon-switch-button" @click="execAction('停止')">确认停止</el-button>
            <el-button v-if="action == '执行'" type="success" size="small" icon="el-icon-position" @click="execAction('执行')">开始执行</el-button>
            <!-- <el-button v-if="action == '全 部'" type="primary" size="small" icon="el-icon-printer" @click="meta.showPrint = true" :disabled="!patient.curr || !condition.term">长期</el-button> -->
            <el-button v-if="!setting.isSimple && action == '全 部'" type="warning" size="small" icon="el-icon-printer" @click="print('长期')" :disabled="!patient.curr">长期</el-button>
            <el-button v-if="!setting.isSimple && action == '全 部'" type="warning" size="small" icon="el-icon-printer" @click="print('临时')" :disabled="!patient.curr">临时</el-button>
            <el-dropdown v-if="action == '全 部'" split-button type="warning" size="small" @click="print('检验汇总单')" @command="print" class="left-pad">
              <i class="el-icon-printer" /> 检验汇总单
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="!patient.curr" command="药品执行单"><i class="el-icon-printer" /> 药品执行单</el-dropdown-item>
                <el-dropdown-item :disabled="!patient.curr" command="检验申请单"><i class="el-icon-printer" /> 检验申请单</el-dropdown-item>
                <el-dropdown-item :disabled="!patient.curr" command="检验条码"><i class="el-icon-printer" /> 检验条码</el-dropdown-item>
                <el-dropdown-item v-if="setting.isSimple && !patient.curr" command="医嘱列表"><i class="el-icon-printer" /> 医嘱列表</el-dropdown-item>
                <el-dropdown-item v-if="setting.isSimple && patient.curr" command="医嘱单"><i class="el-icon-printer" /> 医嘱单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown split-button type="primary" size="small" @click="exportExcel('新开医嘱单')" @command="exportExcel" class="left-pad">
              <i class="el-icon-document"/> 新开医嘱单
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="新停医嘱单"><i class="el-icon-document" /> 新停医嘱单</el-dropdown-item>
                <el-dropdown-item command="小治疗单"><i class="el-icon-document" /> 小治疗单</el-dropdown-item>
                <el-dropdown-item command="药品执行单"><i class="el-icon-document" /> 药品执行单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-row>
        <el-row type="flex" align="middle">
          <el-select v-if="!isEmbed" v-model="patient.curr" value-key="id" placeholder="请选择患者" @change="page" clearable size="small" class="right-pad" filterable>
            <el-option v-for="item in patient.items" :key="item.id" :label="`${item.bedNo}：${item.patientName}`" :value="item" style="height: 3rem">
              <el-badge :value="item.news" :hidden="!item.news" style="margin: 0.5rem 0">
                <el-tag size="small" :type="item.news > 0 ? 'danger' : 'info'" class="right-pad">{{ item.bedNo }}</el-tag>
              </el-badge>

              <b>{{ item.patientName }}</b>
              <span>{{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</span>
            </el-option>
          </el-select>
          <el-date-picker @change="dateChange" style="width: 14rem" size="small" v-model="meta.dates" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          <el-input class="condition-wide left-pad" v-model="condition.keyword" placeholder="医嘱内容" size="small" v-on:keyup.enter.native="page" clearable @clear="page">
            <el-button type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="page"> </el-button>
          </el-input>
        </el-row>
      </el-row>
    </el-header>
    <el-main name="main" style="position: relative">
      <advice-table ref="adviceTable" :action="action" :hospitalization="entity" :is-embed="isEmbed" :condition="condition" @action="execAction" @confirm="confirm" :readonly="readonly" @backed="refresh" />
    </el-main>
    <ProofDialog @ok="execAction" :visible.sync="meta.showProof" :ids="confirmIds" />
    <ResultDialog :visible.sync="meta.showResult" :result="result" />
    <PrintDialog :visible.sync="meta.showPrint" :hospitalization="patient.curr" :type="meta.printType" :condition="condition" :selected="$refs.adviceTable ? $refs.adviceTable.selection : []" />
    <PrintFormDialog :visible.sync="meta.showPrintForm" :hospitalization="patient.curr" :advices="$refs.adviceTable ? $refs.adviceTable.selection : []" :type="meta.printFormType" />
    <ExportAdviceDialog :visible.sync="meta.showExportAdvice" />
    <ExportTreatmentDialog :visible.sync="meta.showExportTreatment" />
    <ExportDrugDialog :visible.sync="meta.showExportDrug" />
  </el-container>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      entity: Object, // 住院记录
    },
    components: {
      AdviceTable: () => import("./_table.vue"),
      ProofDialog: () => import("./dlgConfirm.vue"),
      ResultDialog: () => import("./dlgResult.vue"),
      PrintDialog: () => import("./dlgPrint.vue"),
      PrintFormDialog: () => import("./dlgPrintForm.vue"),
      ExportAdviceDialog: () => import("./dlgExportAdvice.vue"),
      ExportTreatmentDialog: () => import("./dlgExportTreatment.vue"),
      ExportDrugDialog: () => import("./dlgExportDrug.vue"),
    },
    data() {
      return {
        meta: {
          loading: false,
          showProof: false,
          showResult: false,
          showPrint: false,
          showPrintForm: false,
          showExportAdvice: false,
          showExportTreatment: false,
          showExportDrug: false,
          dates: null,
          terms: ["临时", "长期"],
          printType: null,
          printFormType: null,
        },
        patient: {
          items: [],
          curr: null,
        },
        action: "全 部",
        condition: {
          states: null,
          term: "长期",
          keyword: null,
          pageSize: 100,
          pageIndexOnView: 1,
          sort: "id",
          asc: false,
          ifMasterSlave: true, // 只返回主记录，从记录作为主记录属性返回
        },
        confirmIds: [],
        result: null,
        adviceStopped: {
          count: 1,
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission", "setting"]),
      isEmbed() {
        // 是否是嵌入模式
        return this.$route.path != "/advice";
      },
      readonly() {
        return this.entity?.state == "已离院" || this.entity?.state == "已结算";
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // 权限验证
      });
    },
    watch: {
      entity() {
        this.open();
      },
    },
    mounted() {
      if (!this.isEmbed) {
        api.Hospitalization.query({
          state: "已入住",
          pageIndexOnView: 1,
          pageSize: 9999,
          deptCode: this.user.deptCode,
          sort: "bedNo",
          asc: true,
        }).then((res) => {
          this.patient.items = res.items;
          this.queryPatientNews();
        });
      }
      this.open();
    },
    methods: {
      open() {
        if (this.entity) {
          this.patient.curr = this.entity;
        } else {
          this.patient.curr = null;
        }
        this.page();
      },
      page() {
        if (!this.$refs.adviceTable) {
          setTimeout(() => {
            this.page();
          }, 500);
          return;
        }
        if (this.patient.curr) {
          this.condition.hospitalizationId = this.patient.curr.id;
        } else {
          this.patient.curr = null;
          this.condition.hospitalizationId = null;
        }
        if (!this.setting.isSimple) {
          if (this.meta.terms.length == 1) {
            this.condition.term = this.meta.terms[0];
          } else {
            this.condition.term = null;
          }
        }

        this.condition.states = this.action == "全 部" ? null : this.action;

        this.$refs.adviceTable.page();
      },
      queryPatientNews() {
        if (this.patient.items.length) {
          api.Advice.query({
            deptCode: this.user.deptCode,
            state: "待校对",
            ifDetail: false,
            isMaster: true,
          }).then((res) => {
            if (res.items.length) {
              this.patient.items.forEach((item) => {
                this.$set(item, "news", res.items.filter((a) => a.hospitalizationId == item.id).length);
              });
            }
          });
        }
      },
      stateChange(state) {
        this.action = state;
        if (state == "全 部") {
          // 此处需要将 states 置为null，这样 adviceTable 组件内部才会会用之前 全 部 时候的状态来赋值，否则状态查询条件就和列头上的过滤条件不一致
          this.condition.states = null;
        }
        this.$nextTick(() => {
          this.page();
        });
      },
      dateChange(v) {
        if (v) {
          this.condition.startTimeStart = this.$utils.Fmt.startDatetime(v[0]);
          this.condition.startTimeEnd = this.$utils.Fmt.endDatetime(v[1]);
        } else {
          delete this.condition.startTimeStart;
          delete this.condition.startTimeEnd;
        }
        this.page();
      },

      execAction(type, ids, nurseQuestion) {
        if (!ids || !ids.length) {
          ids = this.$refs.adviceTable.selection.map((item) => item.id);
        }
        if (!ids.length) return this.$message.warning("至少要选中一条医嘱！");

        this.meta.loading = true;
        api.Advice.action(type, { ids, nurseQuestion })
          .then((res) => {
            this.result = res;
            this.meta.showResult = true;
            this.refresh();
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },

      confirm(ids) {
        if (!ids || !ids.length) {
          ids = this.$refs.adviceTable.selection.map((item) => item.id);
        }
        if (!ids.length) return this.$message.warning("至少要选中一条医嘱！");
        this.confirmIds = ids;
        this.meta.showProof = true;
      },
      refresh() {
        this.page();
        if (!this.entity) {
          return;
        }
        api.Hospitalization.get(this.entity.id).then((res) => {
          this.$utils.Obj.propertyCopy(res, this.entity, this);
        });
      },
      print(cmd) {
        if (cmd == "检验申请单" || cmd == "检验条码") {
          if (!this.$refs.adviceTable.selection.length) return this.$message.warning("至少要选中一条医嘱！");
          if (this.$refs.adviceTable.selection.filter((item) => item.state != "启用" && item.state != "停止" && item.state != "待停止").length) return this.$message.warning("只允许选择 启用 和 停止 状态的医嘱！");
          if (this.$refs.adviceTable.selection.filter((item) => item.rpClass != "检验").length) return this.$message.warning("只允许选择 检验 类型的医嘱！");
          this.meta.printFormType = cmd;
          this.meta.showPrintForm = true;
          return;
        }
        if (cmd == "药品执行单") {
          this.meta.printType = "口服";
        } else if (cmd == "医嘱单" || cmd == "医嘱列表") {
          this.meta.printType = this.condition.term;
        } else if (cmd == "检验汇总单") {
          if (!this.$refs.adviceTable?.selection || !this.$refs.adviceTable.selection.length) {
            return this.$message.error("请至少选择1条医嘱!");
          }
          for (let i = 0; i < this.$refs.adviceTable.selection.length; i++) {
            let item = this.$refs.adviceTable.selection[i];
            if (item.rpClass != "检验") {
              return this.$message.error("请选择检验类医嘱!");
            }
            item.patient = this.patient.items.find((a) => a.patientCode == item.patientCode);
            if (!item.patient) {
              item.patient = this.patient.curr;
            }
          }
          this.meta.printType = cmd;
        } else {
          return;
        }
        this.meta.showPrint = true;
      },
      exportExcel(cmd) {
        if (cmd == '新开医嘱单') {
          this.meta.showExportAdvice = true;
        } else if (cmd == '新停医嘱单') {
          this.meta.loading = true;
          api.ExportExcel.getAdviceStoppedCount({}).then((res) => {
            this.adviceStopped = res;
            if (this.adviceStopped.count) {
              api.ExportExcel.downloadAdviceStopped({}).then((res) => {
                this.$message.success("导出新停医嘱单成功！");
              }).finally(() => {
                this.meta.loading = false;
              });
            }
          }).finally(() => {
            if (!this.adviceStopped.count) {
              this.meta.loading = false;
              this.$message.error("没有新停医嘱，无法导出！");
            }
          });
        } else if (cmd == '小治疗单') {
          this.meta.showExportTreatment = true;
        } else if (cmd == '药品执行单') {
          this.meta.showExportDrug = true;
        }
      },
    },
  };
</script>
